import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Item from './Item';
import ExcessDetails from './ExcessDetails';
import ExistingFaultDetails from './ExistingFaultDetails';

const Address = ({ address, postCode }) => {
  if (!postCode) {
    return <Item heading="Address" content="Not Available"/>
  }

  return (
    <Item
      heading="Address"
      content={`${address.filter(v => !!v).join(', ')}. ${postCode.toUpperCase()}`}
    />
  )
};

const CoverLevel = ({ coverLevel }) => <Item heading="Cover Level" content={coverLevel ? `£${coverLevel}` : 'N/A'} />;

const CoveredAs = ({ coveredAs }) => <Item heading="Covered As" content={coveredAs ? coveredAs.toUpperCase() : 'Unknown'} />;

const HomeEmergencyDetails = ({ details }) => (
  <Fragment>
    <div style={{
      display: 'block',
      marginBottom: '20px',
      fontWeight: 'bold'
    }}>NO CLAIMS WITHIN FIRST 14 DAYS</div>
    <Address address={[
      details['line1'],
      details['line2'],
      details['line3'],
      details['line4'],
      details['locality'],
      details['town'],
      details['county']
    ]} postCode={details['post_code']} /><br />
    <CoverLevel coverLevel={details['cover_level']} /><br />
    <CoveredAs coveredAs={details['covered_as']} />
    <ExistingFaultDetails existingFault={details['existing_fault']} details={details.details} /><br />
    <ExcessDetails
      claimInInitialPeriod={details['claim_in_initial_period']}
      excessInitialAmount={details['excess_initial_amount']}
      claimInitialPeriodDays={details['claim_initial_period_days']}
      excessNormalAmount={details['excess_normal_amount']}
    />
  </Fragment>
);

HomeEmergencyDetails.propTypes = {
  details: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default HomeEmergencyDetails;



// WEBPACK FOOTER //
// ./src/components/Query/QueryShow/HomeEmergencyDetails.js